export const ACTION = {
  AUTHOR_MANUAL_GRADING_CONFIGURATION_GET: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_GET',
  AUTHOR_MANUAL_GRADING_CONFIGURATION_PUT: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_PUT',
  AUTHOR_MANUAL_GRADING_CONFIGURATION_SET: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_SET',
  AUTHOR_MANUAL_GRADING_CONFIGURATION_DELETE: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_DELETE',

  AUTHOR_MANUAL_GRADING_CONFIGURATION_GET_RESPONSE: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_GET_RESPONSE',
  AUTHOR_MANUAL_GRADING_CONFIGURATION_GET_ERROR: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_GET_ERROR',
  AUTHOR_MANUAL_GRADING_CONFIGURATION_MUTATE_RESPONSE: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_MUTATE_RESPONSE',
  AUTHOR_MANUAL_GRADING_CONFIGURATION_MUTATE_ERROR: 'AUTHOR_MANUAL_GRADING_CONFIGURATION_MUTATE_ERROR',
};

export const RTM_OPERATION = {
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_DELETE: 'author.component.manual.grading.configuration.delete',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_GET: 'author.component.manual.grading.configuration.get',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_SET: 'author.component.manual.grading.configuration.set',
};

export const RTM_REPLY = {
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_DELETE_OK: 'author.component.manual.grading.configuration.delete.ok',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_DELETE_ERROR: 'author.component.manual.grading.configuration.delete.error',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_GET_OK: 'author.component.manual.grading.configuration.get.ok',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_GET_ERROR: 'author.component.manual.grading.configuration.get.error',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_SET_OK: 'author.component.manual.grading.configuration.set.ok',
  AUTHOR_COMPONENT_MANUAL_GRADING_CONFIGURATION_SET_ERROR: 'author.component.manual.grading.configuration.set.error',
};

